export default "__VITE_ASSET__CqqDZQkK__"